import {Action, combineReducers, AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import loaderReducer from './reducer/loaderReducer';
import loginReducer from './reducer/loginReducer';
import messageReducer from './reducer/messageReducer';

const rootReducer = combineReducers({
    login: loginReducer,
    message: messageReducer,
    loader: loaderReducer
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,
    RootState,
    unknown,
    Action<string>>

// Typed dispatch that supports thunks
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>
